<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M20.1008 13.7H22.5008V2.5H11.3008V4.9H20.1008V13.7ZM10.4996 7.2998V11.2998H14.4996V7.2998H16.8996V16.8998H14.4996V13.6998H10.4996V16.8998H8.09961V7.2998H10.4996ZM4.9 11.3V20.1H13.7V22.5H2.5V11.3H4.9Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgHigherLogic',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
